import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import CategorySelection, { type CategorySelectionItem, type CategorySelectionProps } from './CategorySelection';

export interface ControlledCategorySelectionProps<TFieldValues extends FieldValues = FieldValues> extends Omit<CategorySelectionProps, 'value' | 'onChange' | 'error'> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    error?: FieldError;
}

export default function ControlledCategorySelection<TFieldValues extends FieldValues = FieldValues>({
    name,
    control,
    error: errorProp,
    ...props
}: ControlledCategorySelectionProps<TFieldValues>) {
    // Используем useController для работы с формой
    const { field, fieldState } = useController({
        control,
        name,
    });

    const error = fieldState.error || errorProp;

    const handleChange = (value: CategorySelectionItem[]) => {
        field.onChange(value);
    };

    return (
        <CategorySelection
            value={field.value || [{ sectionId: '', categoryId: '' }]}
            onChange={handleChange}
            error={error ? error.message : undefined}
            {...props}
        />
    );
}

